import {Action} from '@ngrx/store';
import {EnclosureCard} from '../../../models/enclosure-card';

export class GetEnclosureCardSuccessAction implements Action {
  public static readonly type = 'GetEnclosureCardsSuccessAction';

  constructor(public enclosureCard: EnclosureCard) {
  }

  public type = GetEnclosureCardSuccessAction.type;
}
